import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import * as Apollo from '@apollo/client';
var defaultOptions = {};
export var CompassLayoutsGetOrganizationConfigDocument = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "CompassLayoutsGetOrganizationConfig"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "slug"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "String"
        }
      }
    }],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "organization"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "slug"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "slug"
            }
          }
        }],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "originalId"
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "configuration"
            },
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "canUseInduction"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "canUseIntegrations"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "hasGamificationAvailable"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "hasStudioAvailable"
                }
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "hasSkillXpEvolutionAvailable"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
};

/**
 * __useCompassLayoutsGetOrganizationConfigQuery__
 *
 * To run a query within a React component, call `useCompassLayoutsGetOrganizationConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompassLayoutsGetOrganizationConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompassLayoutsGetOrganizationConfigQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useCompassLayoutsGetOrganizationConfigQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useQuery(CompassLayoutsGetOrganizationConfigDocument, options);
}
export function useCompassLayoutsGetOrganizationConfigLazyQuery(baseOptions) {
  var options = _objectSpread(_objectSpread({}, defaultOptions), baseOptions);
  return Apollo.useLazyQuery(CompassLayoutsGetOrganizationConfigDocument, options);
}